<div class="google-login-container m-2">
    <div class="google-login-content">
        <h3 class="google-login-title">{{'shared.google.connect.' + context + '.title' | translate}}</h3>

        <div class="google-login-why">
            <h4>{{'shared.google.connect.whyNeeded' | translate}}</h4>
            <ul class="google-login-reasons">
                <li>{{'shared.google.connect.' + context + '.reason1' | translate}}</li>
                <li>{{'shared.google.connect.' + context + '.reason2' | translate}}</li>
                <li>{{'shared.google.connect.' + context + '.reason3' | translate}}</li>
            </ul>
        </div>

        <div class="google-login-access">
            <h4>{{'shared.google.connect.whatWeAccess' | translate}}</h4>
            <p class="google-login-access-text">{{'shared.google.connect.' + context + '.accessDescription' | translate}}</p>
        </div>

        <google-button
            [buttonText]="'shared.google.connect.signInWithGoogle' | translate"
            (buttonClick)="getLoginUrl()">
        </google-button>

        <p class="google-login-disconnect">{{'shared.google.connect.disconnectAnytime' | translate}}</p>
    </div>
</div>